export const ActionTypes = {
  LOADING: "GET_SHARE_DECISION_LOADING",
  ERROR: "GET_SHARE_DECISION_ERROR",
  SUCCESS: "GET_SHARE_DECISION_SUCCESS",
};
